import { withI18n } from 'react-i18next';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';

import { signInActions, isLoggedInSel } from 'src/store/modules/signin';

import DashboardMenu from './DashboardMenu';

const mapStateToProps = (state: any, ownProps: any) => {
  return {
    isLoggedIn: isLoggedInSel(state)
  };
};

const mapDispatchToProps = (dispatch: any): IDispatchFromProps => ({
  signout: () => dispatch(signInActions.signout())
});

export const pureComponent = DashboardMenu;
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withI18n()(withRouter(DashboardMenu)));

interface IDispatchFromProps {
  signout(): void;
}
